import {ObjUtil} from 'yougile-util'
import {Hub} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {Sync} from '@client/sync'
import {DragRectangle, DropArea} from '@common/drag/drag-common'
import {multiActionsWithTasksStore} from '@components/multi-actions-with-tasks/multi-actions-with-tasks-store'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {Column} from '@extensions/column'
import {Task} from '@extensions/task'

export const isAdmin = (): boolean => PermissionsChecker.isAdmin()

export const moreThanOneBoard = (): boolean => {
  let cnt = 0
  const box = Sync.getCurrentSandbox()
  const company = box.getHub(box.companyId)
  company &&
    box.walkForward(company, (obj, level) => {
      if (cnt > 1 || obj.title.startsWith('.') || obj.deleted) {
        return false
      }
      if (level > 2) {
        return false
      }
      if (level === 2) {
        cnt++
        return false
      }
      return true
    })
  return cnt > 1
}

const getRightDropMargin = (): number => {
  const chatPanelOffest = 0
  const chatState = rightPanelStore.state.chatPanel
  return chatState.opened ? chatState.width - chatPanelOffest : 0
}

const getAllowedArea = (): DragRectangle => {
  const chatPanelOffest = 100
  const chatState = rightPanelStore.state.chatPanel
  return {
    top: -100,
    left: -100,
    bottom: -100,
    right: chatState.opened ? chatState.width - chatPanelOffest : -100
  }
}

export const getDropArea = (): DropArea => {
  return {
    top: 115,
    left: -50,
    bottom: 0,
    right: getRightDropMargin(),
    allowedArea: getAllowedArea()
  }
}

export const multiActionMoveTasks = (
  placeholderIndex: number,
  toGroup: Hub,
  isSameGroup: boolean
): void => {
  for (const tasks of ObjUtil.values(
    multiActionsWithTasksStore.state.selectedColumnTasks
  ).reverse()) {
    for (const taskId of isSameGroup
      ? ObjUtil.keys(tasks)
      : ObjUtil.keys(tasks).reverse()) {
      const task = Task.getById(taskId)
      task && Column.taskDropHandler(placeholderIndex, task, toGroup)
    }
  }
}
